

module.exports = __webpack_require__.stylable.create(
    "DropdownNativeSelect2824333219",
    {"classes":{"root":"DropdownNativeSelect2824333219__root","wrapper":"DropdownNativeSelect2824333219__wrapper","arrowIcon":"DropdownNativeSelect2824333219__arrowIcon","errorIcon":"DropdownNativeSelect2824333219__errorIcon","errorIconWrapper":"DropdownNativeSelect2824333219__errorIconWrapper","optionIcon":"DropdownNativeSelect2824333219__optionIcon"},"vars":{},"stVars":{"BorderHoverColor":"color-5","borderHoverColor":"\"color(color-5)\""},"keyframes":{}},
    "",
    8,
    "DropdownNativeSelect2824333219",
    null
);
